import { render } from "./ThongTinDNVT.vue?vue&type=template&id=15e17276"
import script from "./ThongTinDNVT.vue?vue&type=script&lang=js"
export * from "./ThongTinDNVT.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__